module.exports = __webpack_public_path__ + "img/part_tab3_box2_2.bd0aa1df.jpg";